<template>
  <a-layout-sider :class="[theme, 'sider', isMobile ? null : 'shadow']" width="256px" :collapsible="collapsible" v-model="collapsed" :trigger="null">
    <div :class="[collapsed ? 'logo collapsed' : 'logo',theme]">
      
        <img :src="'static/img/logo.png' | baseRoot" @click="goHome" class="goHome"/>
    </div>
    <i-menu :theme="theme" :collapsed="collapsed" :menuData="menuData" @select="onSelect"/>
    <a v-if="!isAdmin" :href="dzsyUrl" class="dzsy">
      <span>电子资质交换</span>
      <img :src="images.icondbArrow" alt="">
    </a>
  </a-layout-sider>
</template>

<script>
import IMenu from "./menu";
import { getCurrentServiceDomain } from "@/libs/common";
import images from '@/config/images';
import { getDzsyAuthPage } from '@/config/dzsy'
export default {
    name: "SiderMenu",
    components: {IMenu},
    props: {
        collapsible: {
            type: Boolean,
            required: false,
            default: false
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false
        },
        menuData: {
            type: Array,
            required: true
        },
        theme: {
            type: String,
            required: false,
            default: "dark"
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.setting.isMobile;
        },
        systemName() {
            return this.$store.state.setting.systemName;
        },
        isAdmin () {
          let userType = localStorage.getItem('userType')
          return 'R01,R02,R03,R04'.includes(userType)
        }
    },
    data () {
      return { 
        images,
        dzsyUrl: getDzsyAuthPage()
      }
    },
    methods: {
        onSelect(obj) {
            this.$emit("menuSelect", obj);
        },
        goHome() {
            // window.location.href = `${getCurrentServiceDomain()}/user/commonHome.htm`;
        }
    }
};
</script>

<style lang="less" scoped>
  .shadow{
    box-shadow: 2px 0 6px rgba(0,21,41,.35);
  }
  .sider{
    z-index: 10;
    &.light{
      background-color: #fff;
    }
    &.dark{
      background-color: #001529;
    }
    .goHome{
      cursor: pointer;
    }
    .logo{
      height: 85px;
      position: relative;
      line-height: 85px;
      padding-left: 23px;
      -webkit-transition: all .3s;
      transition: all .3s;
      overflow: hidden;
      &.collapsed{
       padding-left: 0px;
      }
      &.light{
        background-color: #fff;
        h1{
          color: #1890ff;
        }
      }
      &.dark{
        background-color: #002140;
        h1{
          color: #fff;
        }
      }
      img{
        width: 190px;
        display: inline-block;
        vertical-align: middle;
      }
    }

  }
  .dzsy {
    height: 60px;
    width: 256px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FF6B03;
    color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    cursor: pointer;
    img {
      width: 30px;
      margin-left: 6px;
      margin-top: 2px;
    }
  }
  .ant-layout-sider-children {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/SiderMenu.vue